import type { DataSourceEntity } from "@/api/types/dtos/analytics/AnalyticsDto";

/**
 * Training data sources added in the analytics module expansion.
 * These sources have no geographic coordinates, so MAP graphs are not supported.
 */
export const TRAINING_SOURCE_ENTITIES: DataSourceEntity[] = [
  "TRAINING",
  "TRAINING_ENROLLMENT",
  "TRAININGS_MODULE",
  "TRAININGS_MODULES_TOPIC",
  "TRAININGS_MODULES_TOPICS_CONTENT",
  "TRAINING_CONTENT_PROGRESS",
];

/** Returns true if the given data source is one of the Training sources. */
export const isTrainingSource = (source: DataSourceEntity): boolean =>
  TRAINING_SOURCE_ENTITIES.includes(source);

/**
 * Returns true if MAP graph type is unavailable for the given data source.
 * MAP requires farm coordinates and only makes sense for FARM / CHALLENGE_FORM.
 */
export const isMapDisabledForSource = (source: DataSourceEntity): boolean =>
  isTrainingSource(source);
